export default {
    url: '/finished',
    template: '<evaluation-public-evaluation-finished form-submission="vm.formSubmission"/>',
    resolve: {
        formSubmission (FormSubmissionResource, $stateParams) {
            return FormSubmissionResource.get({ guid: $stateParams.guid, expand: 'form' }).$promise;
        }
    },
    controller (formSubmission) {
        this.formSubmission = formSubmission;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/evaluation/evaluation/finished/index.js